export const videos = [
  {
    id: 'v001',
    title: '清晨的第一缕阳光：城市阳台生活记录',
    author: '晨光日记',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20morning%20balcony%20with%20warm%20sunlight%20and%20green%20plants%20minimal%20stylized%20illustration%20warm%20tones&width=640&height=360&seq=ak-cover-001&orientation=landscape',
    duration: 128,
    category: 'life',
    region: '内地',
    publishDate: '2026-10-13',
    tags: ['生活方式', '清晨', '治愈'],
    description: '用镜头记录一个普通清晨的阳台时光，阳光、绿植和一杯手冲咖啡，慢下来感受生活的温度。',
    views: 182340,
    likes: 12480,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    id: 'v002',
    title: '三分钟看懂街头即兴喜剧的快乐',
    author: '玩笑研究所',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20street%20comedy%20stage%20with%20spotlight%20stylized%20illustration%20warm%20red%20tones&width=640&height=360&seq=ak-cover-002&orientation=landscape',
    duration: 186,
    category: 'entertainment',
    region: '内地',
    publishDate: '2026-10-12',
    tags: ['搞笑', '即兴', '喜剧'],
    description: '街头即兴喜剧的经典片段合集，看看演员如何用一个眼神把路人逗笑。',
    views: 356210,
    likes: 28760,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  },
  {
    id: 'v003',
    title: '手作皮具入门：从一块皮料到一个卡包',
    author: '匠人手记',
    cover: 'https://readdy.ai/api/search-image?query=leather%20craft%20workshop%20tools%20on%20wooden%20table%20stylized%20illustration%20warm%20brown%20tones&width=640&height=360&seq=ak-cover-003&orientation=landscape',
    duration: 245,
    category: 'hobby',
    region: '内地',
    publishDate: '2026-10-10',
    tags: ['手作', '皮具', '教程'],
    description: '零基础也能上手的手作皮具教程，一步步教你完成一个属于自己的卡包。',
    views: 96450,
    likes: 8930,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  },
  {
    id: 'v004',
    title: '深夜清唱：一个人的民谣现场',
    author: '木吉他小站',
    cover: 'https://readdy.ai/api/search-image?query=acoustic%20guitar%20in%20dim%20room%20with%20warm%20lamp%20light%20stylized%20illustration%20amber%20tones&width=640&height=360&seq=ak-cover-004&orientation=landscape',
    duration: 172,
    category: 'music',
    region: '港台',
    publishDate: '2026-10-11',
    tags: ['民谣', '清唱', '现场'],
    description: '没有舞台和灯光，只有一把木吉他和深夜的安静，唱给同样睡不着的人。',
    views: 142870,
    likes: 15620,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  },
  {
    id: 'v005',
    title: '五分钟学会一段爵士律动',
    author: '舞步计划',
    cover: 'https://readdy.ai/api/search-image?query=jazz%20dance%20studio%20mirror%20warm%20spotlight%20stylized%20illustration%20deep%20red%20tones&width=640&height=360&seq=ak-cover-005&orientation=landscape',
    duration: 158,
    category: 'dance',
    region: '欧美',
    publishDate: '2026-10-09',
    tags: ['爵士', '舞蹈教学', '律动'],
    description: '把复杂的爵士律动拆成五个简单动作，跟着节奏就能跳起来。',
    views: 210540,
    likes: 19450,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    id: 'v006',
    title: '凌晨两点的深夜食堂：一碗热汤面',
    author: '深夜厨房',
    cover: 'https://readdy.ai/api/search-image?query=steaming%20noodle%20bowl%20late%20night%20kitchen%20warm%20lamp%20stylized%20illustration%20warm%20amber%20tones&width=640&height=360&seq=ak-cover-006&orientation=landscape',
    duration: 96,
    category: 'food',
    region: '内地',
    publishDate: '2026-10-14',
    tags: ['美食', '夜宵', '治愈'],
    description: '凌晨两点的一碗热汤面，是给失眠者最好的安慰。',
    views: 428910,
    likes: 35240,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
  },
  {
    id: 'v007',
    title: '一个人骑行 120 公里的海边公路',
    author: '在路上',
    cover: 'https://readdy.ai/api/search-image?query=coastal%20road%20cycling%20at%20sunset%20stylized%20illustration%20warm%20orange%20tones&width=640&height=360&seq=ak-cover-007&orientation=landscape',
    duration: 268,
    category: 'travel',
    region: '内地',
    publishDate: '2026-10-08',
    tags: ['骑行', '海边', '旅行'],
    description: '沿着海岸线骑行一百二十公里，风吹过耳边的那一刻，所有疲惫都值了。',
    views: 173220,
    likes: 16310,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  },
  {
    id: 'v008',
    title: '为什么越长大越难交到新朋友',
    author: '城市情感观察',
    cover: 'https://readdy.ai/api/search-image?query=two%20people%20talking%20in%20city%20cafe%20evening%20stylized%20illustration%20muted%20rose%20tones&width=640&height=360&seq=ak-cover-008&orientation=landscape',
    duration: 214,
    category: 'emotion',
    region: '内地',
    publishDate: '2026-10-12',
    tags: ['情感', '社交', '都市'],
    description: '成年人的友谊为什么越来越稀疏？聊聊那些说不出口的孤独感。',
    views: 289470,
    likes: 26180,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    id: 'v009',
    title: '周末改造出租屋：五百块换一面墙',
    author: '小屋改造',
    cover: 'https://readdy.ai/api/search-image?query=renovated%20rental%20room%20with%20paint%20and%20warm%20lights%20stylized%20illustration%20warm%20neutral%20tones&width=640&height=360&seq=ak-cover-009&orientation=landscape',
    duration: 142,
    category: 'life',
    region: '内地',
    publishDate: '2026-10-07',
    tags: ['家居', '改造', '生活'],
    description: '预算五百块也能让出租屋焕然一新，分享三个最划算的改造思路。',
    views: 118760,
    likes: 11240,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4',
  },
  {
    id: 'v010',
    title: '模仿秀：一个人演完整个剧组',
    author: '百变阿六',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20theater%20masks%20and%20costumes%20stylized%20illustration%20warm%20red%20tones&width=640&height=360&seq=ak-cover-010&orientation=landscape',
    duration: 88,
    category: 'entertainment',
    region: '内地',
    publishDate: '2026-10-13',
    tags: ['模仿', '搞笑', '短剧'],
    description: '一个人分饰多角，三十秒演完一部家庭伦理大戏。',
    views: 512330,
    likes: 42890,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    id: 'v011',
    title: '旧相机翻新记：让胶片重新转动',
    author: '收藏阁楼',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20film%20camera%20restoration%20on%20workbench%20stylized%20illustration%20warm%20sepia%20tones&width=640&height=360&seq=ak-cover-011&orientation=landscape',
    duration: 231,
    category: 'hobby',
    region: '港台',
    publishDate: '2026-10-06',
    tags: ['胶片', '相机', '收藏'],
    description: '从旧货市场淘来的胶片相机，经过一步步拆解清洁后重新按下快门。',
    views: 78340,
    likes: 7420,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  },
  {
    id: 'v012',
    title: '卧室翻唱：把老歌唱出新味道',
    author: '晚安电台',
    cover: 'https://readdy.ai/api/search-image?query=bright%20bedroom%20with%20microphone%20and%20fairy%20lights%20stylized%20illustration%20warm%20pink%20tones&width=640&height=360&seq=ak-cover-012&orientation=landscape',
    duration: 165,
    category: 'music',
    region: '日韩',
    publishDate: '2026-10-11',
    tags: ['翻唱', '老歌', '卧室'],
    description: '用最简单的设备录下最真诚的声音，经典歌曲的新编曲版本。',
    views: 231640,
    likes: 21370,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  },
  {
    id: 'v013',
    title: '街舞基础教学：从律动到定格',
    author: 'B-Boy 阿泽',
    cover: 'https://readdy.ai/api/search-image?query=street%20dance%20practice%20urban%20concrete%20stylized%20illustration%20deep%20red%20tones&width=640&height=360&seq=ak-cover-013&orientation=landscape',
    duration: 197,
    category: 'dance',
    region: '内地',
    publishDate: '2026-10-05',
    tags: ['街舞', '教学', '基础'],
    description: '想学街舞却不知道从哪开始？先把律动和定格练熟，进步会非常快。',
    views: 167890,
    likes: 15830,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  },
  {
    id: 'v014',
    title: '苍蝇馆子探秘：藏在巷子里的三十年老味道',
    author: '寻味地图',
    cover: 'https://readdy.ai/api/search-image?query=small%20alley%20restaurant%20with%20steaming%20dishes%20stylized%20illustration%20warm%20amber%20tones&width=640&height=360&seq=ak-cover-014&orientation=landscape',
    duration: 176,
    category: 'food',
    region: '内地',
    publishDate: '2026-10-10',
    tags: ['探店', '老味道', '美食'],
    description: '没有招牌也没有菜单，开了三十年的小馆子却天天排队。',
    views: 342180,
    likes: 29840,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    id: 'v015',
    title: '独自旅行：在陌生城市待到日落',
    author: '慢游者',
    cover: 'https://readdy.ai/api/search-image?query=lone%20traveler%20walking%20old%20city%20street%20at%20dusk%20stylized%20illustration%20warm%20orange%20tones&width=640&height=360&seq=ak-cover-015&orientation=landscape',
    duration: 254,
    category: 'travel',
    region: '日韩',
    publishDate: '2026-10-04',
    tags: ['独行', '城市漫步', '日落'],
    description: '一个人的旅行到底是什么感觉？在陌生城市里慢慢走到日落。',
    views: 156420,
    likes: 14730,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
  },
  {
    id: 'v016',
    title: '异地恋到底能不能走到最后',
    author: '情感树洞',
    cover: 'https://readdy.ai/api/search-image?query=phone%20video%20call%20at%20night%20warm%20lamp%20stylized%20illustration%20muted%20rose%20tones&width=640&height=360&seq=ak-cover-016&orientation=landscape',
    duration: 203,
    category: 'emotion',
    region: '内地',
    publishDate: '2026-10-09',
    tags: ['异地恋', '情感', '观察'],
    description: '距离真的会打败感情吗？三个真实故事给出了不同答案。',
    views: 267530,
    likes: 24310,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  },
  {
    id: 'v017',
    title: '懒人早餐：十分钟搞定一周的能量来源',
    author: '晨光日记',
    cover: 'https://readdy.ai/api/search-image?query=healthy%20breakfast%20table%20with%20fruits%20and%20coffee%20stylized%20illustration%20warm%20cream%20tones&width=640&height=360&seq=ak-cover-017&orientation=landscape',
    duration: 118,
    category: 'life',
    region: '欧美',
    publishDate: '2026-10-13',
    tags: ['早餐', '食谱', '生活'],
    description: '十分钟准备、一周不重样的能量早餐，健康又省事。',
    views: 198340,
    likes: 17650,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    id: 'v018',
    title: '街头采访：成年人最想对十八岁的自己说什么',
    author: '玩笑研究所',
    cover: 'https://readdy.ai/api/search-image?query=street%20interview%20with%20microphone%20in%20city%20stylized%20illustration%20warm%20red%20tones&width=640&height=360&seq=ak-cover-018&orientation=landscape',
    duration: 212,
    category: 'entertainment',
    region: '内地',
    publishDate: '2026-10-12',
    tags: ['街访', '话题', '娱乐'],
    description: '把话筒递到路人面前，没想到答案一个比一个扎心。',
    views: 421760,
    likes: 36420,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4',
  },
  {
    id: 'v019',
    title: '零基础水彩：一片晚霞就够了',
    author: '匠人手记',
    cover: 'https://readdy.ai/api/search-image?query=watercolor%20painting%20sunset%20palette%20on%20desk%20stylized%20illustration%20warm%20orange%20tones&width=640&height=360&seq=ak-cover-019&orientation=landscape',
    duration: 187,
    category: 'hobby',
    region: '内地',
    publishDate: '2026-10-03',
    tags: ['水彩', '绘画', '教学'],
    description: '三个颜色、一把平刷，画出属于你的一片晚霞。',
    views: 88210,
    likes: 9210,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    id: 'v020',
    title: '钢琴即兴：把心情弹成旋律',
    author: '木吉他小站',
    cover: 'https://readdy.ai/api/search-image?query=piano%20keys%20close%20up%20warm%20studio%20light%20stylized%20illustration%20amber%20tones&width=640&height=360&seq=ak-cover-020&orientation=landscape',
    duration: 149,
    category: 'music',
    region: '欧美',
    publishDate: '2026-10-08',
    tags: ['钢琴', '即兴', '纯音乐'],
    description: '没有乐谱，跟着当下的心情随意弹奏，意外地很治愈。',
    views: 134560,
    likes: 13820,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  },
  {
    id: 'v021',
    title: 'K-Pop 副歌分解教学',
    author: '舞步计划',
    cover: 'https://readdy.ai/api/search-image?query=kpop%20dance%20practice%20room%20neon%20stylized%20illustration%20deep%20red%20tones&width=640&height=360&seq=ak-cover-021&orientation=landscape',
    duration: 168,
    category: 'dance',
    region: '日韩',
    publishDate: '2026-10-11',
    tags: ['K-Pop', '教学', '副歌'],
    description: '热门副歌慢速分解，跟着数拍就能学会。',
    views: 289140,
    likes: 26730,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  },
  {
    id: 'v022',
    title: '一个人的宵夜仪式感',
    author: '深夜厨房',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20late%20night%20snack%20table%20with%20candle%20stylized%20illustration%20warm%20amber%20tones&width=640&height=360&seq=ak-cover-022&orientation=landscape',
    duration: 92,
    category: 'food',
    region: '港台',
    publishDate: '2026-10-14',
    tags: ['宵夜', '仪式感', '美食'],
    description: '一个人吃宵夜也要认真摆盘，这是属于大人的小小仪式感。',
    views: 174320,
    likes: 16240,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  },
  {
    id: 'v023',
    title: '周末去哪：城市周边的隐秘露营地',
    author: '在路上',
    cover: 'https://readdy.ai/api/search-image?query=night%20camping%20tent%20with%20warm%20string%20lights%20stylized%20illustration%20warm%20orange%20tones&width=640&height=360&seq=ak-cover-023&orientation=landscape',
    duration: 226,
    category: 'travel',
    region: '内地',
    publishDate: '2026-10-07',
    tags: ['露营', '周边游', '周末'],
    description: '离城市一小时车程的隐秘营地，星空和篝火都准备好了。',
    views: 143980,
    likes: 13420,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    id: 'v024',
    title: '成年人的崩溃往往是无声的',
    author: '城市情感观察',
    cover: 'https://readdy.ai/api/search-image?query=lone%20person%20on%20night%20subway%20platform%20stylized%20illustration%20muted%20rose%20tones&width=640&height=360&seq=ak-cover-024&orientation=landscape',
    duration: 195,
    category: 'emotion',
    region: '内地',
    publishDate: '2026-10-06',
    tags: ['情感', '都市', '共鸣'],
    description: '白天若无其事，夜里独自消化，这是很多成年人的日常。',
    views: 312470,
    likes: 28940,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
  },
  {
    id: 'v025',
    title: '断舍离实践：扔掉三百件东西之后',
    author: '小屋改造',
    cover: 'https://readdy.ai/api/search-image?query=minimal%20tidy%20room%20with%20few%20objects%20stylized%20illustration%20warm%20neutral%20tones&width=640&height=360&seq=ak-cover-025&orientation=landscape',
    duration: 134,
    category: 'life',
    region: '内地',
    publishDate: '2026-10-02',
    tags: ['断舍离', '极简', '生活'],
    description: '清理掉三百件物品后，房间和生活都变得轻松了。',
    views: 121340,
    likes: 11870,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  },
  {
    id: 'v026',
    title: '素人挑战：用方言讲冷笑话',
    author: '百变阿六',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20microphone%20stage%20warm%20red%20curtain%20stylized%20illustration%20warm%20red%20tones&width=640&height=360&seq=ak-cover-026&orientation=landscape',
    duration: 78,
    category: 'entertainment',
    region: '内地',
    publishDate: '2026-10-13',
    tags: ['方言', '冷笑话', '挑战'],
    description: '让路人用方言讲冷笑话，结果自己先绷不住了。',
    views: 386920,
    likes: 33120,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    id: 'v027',
    title: '模型涂装入门：从素组到成品',
    author: '收藏阁楼',
    cover: 'https://readdy.ai/api/search-image?query=model%20kit%20painting%20hobby%20desk%20with%20brushes%20stylized%20illustration%20warm%20sepia%20tones&width=640&height=360&seq=ak-cover-027&orientation=landscape',
    duration: 219,
    category: 'hobby',
    region: '港台',
    publishDate: '2026-10-05',
    tags: ['模型', '涂装', '手作'],
    description: '从打磨到上色，完整演示一个模型的新生过程。',
    views: 69340,
    likes: 6840,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4',
  },
  {
    id: 'v028',
    title: '深夜爵士：萨克斯与雨的对话',
    author: '晚安电台',
    cover: 'https://readdy.ai/api/search-image?query=saxophone%20under%20rain%20with%20city%20lights%20stylized%20illustration%20amber%20tones&width=640&height=360&seq=ak-cover-028&orientation=landscape',
    duration: 208,
    category: 'music',
    region: '欧美',
    publishDate: '2026-10-09',
    tags: ['爵士', '萨克斯', '深夜'],
    description: '雨夜配上萨克斯，是城市里最浪漫的噪音。',
    views: 148760,
    likes: 14230,
    src: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
];